import { defineMessages } from 'react-intl';

import { sharedMessages } from '@app/translations';

export const footerMessages = defineMessages({
  disclaimer: { id: 'footerLinks.disclaimer', defaultMessage: 'Disclaimer' },
  privacyPolicy: {
    id: 'footerLinks.privacyPolicy',
    defaultMessage: 'Privacy policy',
  },
  EBSCOHelp: { id: 'footerLinks.EBSCOHelp', defaultMessage: 'EBSCO Help' },
  footerLinks: { id: 'footer.footerLinks', defaultMessage: 'Footer links' },
  termsOfUse: sharedMessages.termsOfUse,
});
